import React, {useEffect, useState} from "react";
import axios from 'axios';

import MarkdownRenderer from "./MarkdownRenderer";

export default function Services() {
  const [services, setServices] = useState([])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_STRAPI_API_URL}/services?populate=*`, {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
      }
    }).then(res => {
      setServices(res.data.data);
    }).catch(err => console.error(err));
  }, [])

  return (
    <section className="py-16 bg-white text-gray-800 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-10">Dịch vụ của VeraLeaf</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const imgUrl =  process.env.REACT_APP_STRAPI_URL + service.image?.url
            return(
              <div key={index} className="shadow-lg rounded-xl overflow-hidden">
                <img src={imgUrl} alt={service.title} className="w-full h-48 object-cover" />
                <div className="p-4">
                  <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                  <MarkdownRenderer content={service.description} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
